import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOrder, editOrder, clearOrdersErrors, setFulfillment } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditOrder from '../components/orders/EditOrder.js';
import Alert from '../components/home/Alert';
import Snackbar from 'material-ui/Snackbar';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  order: PropTypes.object,
  orders: PropTypes.object,
  orderId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  items: PropTypes.array,
  itemsMeta: PropTypes.object,
  router: PropTypes.object,
  draw: PropTypes.any,
}

class OrderEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      openDeleteConfirmation: false,
      viewRedirect: false,
      draw: false,
      openSnackbar: false,
      snackbarMessage: 'Order Updated!'
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const query = this.props.query;
    const router = this.props.router;
    if (!query.page) {
      query.page = 1;
      query.orderId = this.props.orderId;
      router.push({ pathname: location.pathname, query });
    }
    this.props.dispatch(fetchOrder(this.props.orderId));
  }

  componentWillReceiveProps(nextProps) {
    // console.log("**ORDER**", this.props.order)
    const order = nextProps.order;
    const nextState = { order };
    if (nextProps.error) {
      // console.log("*ERROR*", nextProps.error)
      _.merge(nextState, {
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode || ''} ${nextProps.error.error || ''} ${nextProps.error.message || ''}`,
        error: true,
        fullError: nextProps.error,
      });
    }

    if (nextProps.order && !nextProps.error && this.state.edited) {
      //  console.log("Order Edited Fields:",
      //   "props.order",this.props.order.notes.order.length,  
      //   "nextProps.order",nextProps.order.notes.order.length
      //  );
      _.merge(nextState, {
        alertOpen: false,
        alertMessage: 'Order edited succesfully!',
        error: false,
      });
    }
    this.setState(nextState);
  }
  openDeleteConfirmation(type, key) {
    if (type === 'itemToDelete') {
      this.setState({
        openDeleteConfirmation: true,
        itemToDelete: key,
      });
    }
  }
  handleCloseDeleteConfirmation() {
    this.setState({
      openDeleteConfirmation: false,
      altImageToDelete: 0,
      itemToDelete: 0,
    });
  }
  handleDelete() {
    const order = this.props.order;
    this.setState({ order });
    this.handleCloseDeleteConfirmation();
  }
  saveEditOrder(order) {
    this.setState({
      edited: true,
    });
    const mapObjRecursive = (obj) => {
      const parsedObj = obj;
      delete parsedObj.rawOrder;
      Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') parsedObj[key] = mapObjRecursive(obj[key]);
        else parsedObj[key] = ((key === 'sourceId' || key === 'cartId') && obj[key] === null) ? ' ' : obj[key];
      });
      return parsedObj;
    };
    const pOrder = mapObjRecursive(order);
    this.props.dispatch(editOrder(pOrder));
  }
  sendToFulfillment(order, sendTo) {
    this.setState({ edited: true, openSnackbar: true, snackbarMessage: 'Sending to Fulfillment...' })
    const mapObjRecursive = (obj) => {
      const parsedObj = obj;
      delete parsedObj.rawOrder;
      Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') parsedObj[key] = mapObjRecursive(obj[key]);
        else parsedObj[key] = ((key === 'sourceId' || key === 'cartId') && obj[key] === null) ? ' ' : obj[key];
      });
      return parsedObj;
    };
    const pOrder = mapObjRecursive(order);
    this.props.dispatch(setFulfillment(pOrder, sendTo));
  }
  navigation(route) {
    this.props.dispatch(fetchOrder(route));
  }
  navigateToView(order) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    const pOrder = order;
    delete pOrder.rawOrder;
    this.props.dispatch(editOrder(pOrder));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
      error: false,
    });
    this.props.dispatch(clearOrdersErrors());
    const { error, viewRedirect } = this.state;
    switch (true) {
      case (viewRedirect):
        this.setState({ viewRedirect: false });
        browserHistory.push(`/orders/view/${this.props.order.id}`);
        break;
      case (error):
        this.props.dispatch(fetchOrder(this.props.orderId));
        break;
      default:
        browserHistory.push('/orders?page=1');
        break;
    }
  }

  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="orders component" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditOrder
          order={this.props.order}
          onSave={data => this.saveEditOrder(data)}
          onFulfillment={(data, sendTo )=> this.sendToFulfillment(data, sendTo)}
          onView={data => this.navigateToView(data)}
        />
        <Snackbar
          open={this.state.openSnackbar}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
        />
      </div>
    );
  }
}

OrderEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OrderEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    draw: state.orders.draw,
    order: state.orders.order,
    orders: state.orders,
    orderId: ownProps.params.id,
    error: state.orders.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(OrderEditPage));



// WEBPACK FOOTER //
// ./src/containers/OrderEditPage.js